// extracted by mini-css-extract-plugin
export default {"moviesGrid":"MoviesGrid_moviesGrid__2DQML"};